import React from 'react';
import Header from '../../Shared/Header';
import BreadCums from '../../Shared/BreadCums';
import FaqQuestion from './FaqQuestion';
import Apps from '../../Shared/Apps';
import Footer3 from '../../Shared/Footer3';

const Faq = () => {
    return (
        <>
            <Header
                parentMenu='pages'
                headerClass='sc-header-section inner-header-style'
                signUpBtn='inner-btn'
            />
            <BreadCums pageTitle='Faq' />
            <FaqQuestion />
            <Apps />
            <Footer3 />
        </>
    );
};

export default Faq;
